// frontend/src/components/cash-close/HorizonToggle.js
import React from 'react';
import { useTheme, sans, green, greenLight, greenDark } from '../../tokens';

const OPTIONS = [
  { key: 'MTD',  label: 'MTD' },
  { key: 'Full', label: 'Full' },
  { key: 'QTD',  label: 'QTD' },
  { key: 'YTD',  label: 'YTD' },
  { key: 'LTM',  label: 'LTM' },
  { key: 'Plan', label: 'Plan' },
];

export default function HorizonToggle({ value, onChange }) {
  const t = useTheme();
  return (
    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
      {OPTIONS.map(opt => {
        const active = value === opt.key;
        return (
          <button
            key={opt.key}
            onClick={() => onChange(opt.key)}
            style={{
              padding: '4px 12px', borderRadius: 14, fontSize: 11, fontFamily: sans, fontWeight: active ? 600 : 400,
              border: `1px solid ${active ? green : t.border}`,
              background: active ? greenLight : 'transparent',
              color: active ? greenDark : t.textSecondary,
              cursor: 'pointer',
            }}
          >{opt.label}</button>
        );
      })}
    </div>
  );
}
